"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _keyDownHandler = _interopRequireDefault(require("../../handlers/keyDownHandler"));

var _Icons = _interopRequireDefault(require("./Icons"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CheckboxRadio = function CheckboxRadio(props) {
  var label = props.label,
      className = props.className,
      style = props.style,
      id = props.id,
      tabIndex = props.tabIndex,
      description = props.description,
      helperText = props.helperText,
      extraContent = props.extraContent,
      rest = _objectWithoutProperties(props, ["label", "className", "style", "id", "tabIndex", "description", "helperText", "extraContent"]);

  var newID = id;

  if (newID === null) {
    newID = "box-" + rest.type + "-" + Math.floor(Math.random() * 100000000);
  }

  var classes = (0, _classnames["default"])("radio-checkbox", className);
  var hasDesc = description && description !== "" || extraContent;
  var labelClass = (0, _classnames["default"])({
    "descriptionLabel": hasDesc,
    "helperTextLabel": helperText && helperText !== "" && !hasDesc
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "checkboxRadio-component"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes,
    style: style,
    tabIndex: tabIndex,
    onKeyDown: function onKeyDown(event) {
      var key = _keyDownHandler["default"].getKeysFromEvent(event);

      if (key === _keyDownHandler["default"].keys.spacebar) {
        event.preventDefault(); // Simulates onChange. we cannot just use the ref of the input and call onchange() on it.
        // the onchange is not defined at this place.

        props.onChange({
          target: {
            value: props.value,
            checked: !props.checked
          }
        });
      }
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "item-radio-checkbox"
  }, /*#__PURE__*/_react["default"].createElement("input", _extends({}, rest, {
    id: newID
  })), /*#__PURE__*/_react["default"].createElement("label", {
    className: labelClass,
    htmlFor: newID,
    key: newID
  }, label, description && description !== "" && /*#__PURE__*/_react["default"].createElement("span", {
    className: "description"
  }, description), helperText && helperText !== "" && /*#__PURE__*/_react["default"].createElement("div", {
    className: "item-helper-text"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "helper-text"
  }, helperText)), extraContent && extraContent !== "" && /*#__PURE__*/_react["default"].createElement("div", {
    className: "extraContent"
  }, extraContent)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "check"
  }, /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
    name: "micro-glyph-checkmark"
  })))));
};

CheckboxRadio.propTypes = {
  type: _propTypes["default"].oneOf(["checkbox", "radio"]),
  name: _propTypes["default"].string,
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].object]),
  value: _propTypes["default"].string,
  checked: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  className: _propTypes["default"].string,
  style: _propTypes["default"].object,
  tabIndex: _propTypes["default"].number,
  id: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  description: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].object]),
  helperText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].object]),
  extraContent: _propTypes["default"].any
};
CheckboxRadio.defaultProps = {
  type: "radio",
  name: "",
  value: "",
  label: null,
  checked: false,
  disabled: false,
  onChange: function onChange() {},
  className: "",
  style: {},
  tabIndex: 1,
  id: null,
  description: "",
  helperText: "",
  extraContent: null
};
var _default = CheckboxRadio;
exports["default"] = _default;